
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { FiHome, FiGrid, FiFolder, FiChevronDown, FiMessageSquare, FiUser, FiLock, FiTag, FiPlusSquare, FiLayers, FiList, FiDollarSign, FiFileText, FiChevronsDown } from "react-icons/fi";
import { HiOutlineClipboardList } from "react-icons/hi";
import { RiFileListLine } from "react-icons/ri";
import { MdOutlineAssignment, MdOutlineManageAccounts } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { MdAccountBalanceWallet } from "react-icons/md";
import { motion } from "framer-motion";
import { useSidebar } from "units/dashboard/context/SidebarProvider";
import { setActiveItem } from "units/dashboard/store/menuSlice";
import { useDispatch } from "react-redux";
import feather from 'feather-icons'
import { FaFileInvoiceDollar, FaHandHoldingUsd, FaMoneyBillWave } from "react-icons/fa";
const AdminSidebar = ({ isChatBotVisible, toggleChatBotVisibility }) => {
    const [openMenu, setOpenMenu] = useState(null);
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const sidebarRef = useRef(null)
    useEffect(() => {
        const handleClickOutside = (event) => {
            const button = document.getElementById('vertical-menu-btn'); // اگر دکمه هدر داری
            if (sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                button && !button.contains(event.target)) {
                if (isSidebarOpen) toggleSidebar();
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [isSidebarOpen, toggleSidebar]);
    const dispatch = useDispatch()
    useEffect(() => {
        feather.replace();
    }, []);
    const toggleMenu = (menuKey) => {
        setOpenMenu(openMenu === menuKey ? null : menuKey);
    };
    const handleClick = (menuItem) => {

        dispatch(setActiveItem(menuItem));
        // navigate(`/bot/chat/${menuItem}`); 
        // toggleChatBotVisibility

    };

    return (
        <SimpleBar data-simplebar
            ref={(el) => { sidebarRef.current = el?.getScrollElement() || el; }}
            className={`h-full  ${isSidebarOpen ? 'open' : 'closed'}`} >
            <div id="sidebar-menu">
                <ul className="metismenu" id="side-menu">
                    <li className="menu-heading px-4 py-3.5 text-xs font-medium text-gray-500 cursor-default">
                        منو
                    </li>

                    {/* داشبورد */}
                    <li>
                        <NavLink
                            to="/admin/dashboard"

                            className={({ isActive }) =>
                                `flex items-center pl-6 pr-4 py-3 text-sm font-medium transition-all duration-150 ease-linear 
                                ${isActive ? "bg-[#aadec5] font-bold" : "text-gray-700 hover:text-green-500"}`
                            }
                        >
                            <FiHome className="mr-2 text-lg" />
                            <span data-key="t-dashboard"> داشبورد</span>
                        </NavLink>
                    </li>
                    {/* طرح */}
                    <li>
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu("plan")
                            }}
                            className="w-full flex items-center justify-between pl-1 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <MdOutlineManageAccounts className="mr-2 text-lg" />
                            <span data-key="t-apps" className="w-full">مدیریت طرح ها
                                <FiChevronDown className={`mr-[5rem] transform transition-transform ${openMenu === "plan" ? "rotate-180" : "rotate-0"} `} />
                            </span>

                        </a>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "plan" ? "auto" : 0, opacity: openMenu === "plan" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/create-plan'
                                    onClick={() => handleClick("createPlan")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FiPlusSquare className="mr-2 text-sm" />

                                    ایجاد طرح
                                </NavLink>
                            </li>
                        </motion.ul>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "plan" ? "auto" : 0, opacity: openMenu === "plan" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/plans'
                                    onClick={() => handleClick("myPlans")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FiList className="mr-2 text-sm" />
                                    لیست طرح ها
                                </NavLink>
                            </li>
                        </motion.ul>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "plan" ? "auto" : 0, opacity: openMenu === "plan" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/offer-codes'
                                    onClick={() => handleClick("offerCodes")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FiTag className="mr-2 text-sm" />
                                    کد تخفیف
                                </NavLink>
                            </li>
                        </motion.ul>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "plan" ? "auto" : 0, opacity: openMenu === "plan" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/user-plan-list'
                                    onClick={() => handleClick("userPlansList")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <HiOutlineClipboardList className="mr-2 text-sm" />
                                    طرح های خریداری شده
                                </NavLink>
                            </li>
                        </motion.ul>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "plan" ? "auto" : 0, opacity: openMenu === "plan" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/plan-request'
                                    onClick={() => handleClick("personalPlanRequest")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <RiFileListLine className="mr-2 text-sm" />
                                    لیست درخواست طرح
                                </NavLink>
                            </li>
                        </motion.ul>

                    </li>
                    {/* مدیریت گفتگوها */}
                    <li>
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu("chats")
                            }}
                            className="w-full flex items-center justify-between pl-1 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <FiGrid className="mr-2 text-lg" />
                            <span data-key="t-apps" className="w-full">مدیریت گفتگوها
                                <FiChevronDown className={`mr-[4.49rem] transform transition-transform ${openMenu === "chats" ? "rotate-180" : "rotate-0"} `} />
                            </span>

                        </a>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "chats" ? "auto" : 0, opacity: openMenu === "chats" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/bot/chat/supportBot'
                                    onClick={() => handleClick("supportBot")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FiMessageSquare className="mr-2 text-sm" />
                                    لیست گفتگوها
                                </NavLink>
                            </li>
                        </motion.ul>
                    </li>

                    {/* لیست بات‌ها */}
                    <li>
                        <NavLink
                            to="/admin/publish"
                            className={({ isActive }) =>
                                `flex items-center pl-6 pr-4 py-3 text-sm font-medium transition-all duration-150 ease-linear 
                ${isActive ? "bg-[#aadec5] font-bold" : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                            }
                        >
                            <FiFolder className="mr-2 text-lg" />
                            <span data-key="t-dashboard"> لیست بات های درخواستی </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/admin/settlement-requests"
                            className={({ isActive }) =>
                                `flex items-center pl-6 pr-4 py-3 text-sm font-medium transition-all duration-150 ease-linear 
                            ${isActive ? "bg-[#aadec5] font-bold" : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                            }
                        >
                            <FiFolder className="mr-2 text-lg" />
                            <span data-key="t-dashboard">لیست درخواست های تسویه </span>
                        </NavLink>
                    </li>
                    {/* مدیریت مالی */}
                    <li>
                        <a
                            onClick={(e) => { e.stopPropagation(); toggleMenu("FinanceManager") }}
                            className="w-full flex items-center justify-between pl-1 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <FaMoneyBillWave className="mr-2 text-lg" />
                            <span data-key="t-apps" className="w-full">مدیریت مالی
                                <FiChevronDown className={`mr-[5.8rem] transform transition-transform ${openMenu === "FinanceManager" ? "rotate-180" : "rotate-0"} `} />
                            </span>

                        </a>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "FinanceManager" ? "auto" : 0, opacity: openMenu === "FinanceManager" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/transactions-list'
                                    onClick={() => handleClick("transactionsList")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FaFileInvoiceDollar className="mr-2 text-sm" />
                                    صورت حساب
                                </NavLink>
                            </li>
                        </motion.ul>
                    </li>

                    {/* مدیریت قیف */}
                    <li>
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu("FunnelManager");
                            }}
                            className="w-full flex items-center justify-between pl-2 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <div className="flex items-center">
                                <FiLayers className="mr-2 text-lg" />
                                <span>مدیریت قیف</span>
                            </div>

                            <FiChevronDown
                                className={`transform transition-transform ${openMenu === "FunnelManager"
                                        ? "rotate-180"
                                        : "rotate-0"
                                    }`}
                            />
                        </a>

                        {/* ایجاد معیار */}
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{
                                height: openMenu === "FunnelManager" ? "auto" : 0,
                                opacity: openMenu === "FunnelManager" ? 1 : 0,
                            }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to="/admin/create-funnel-criteria"
                                    onClick={() => handleClick("createFunnelCriteria")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear
                    ${isActive
                                            ? "bg-[#aadec5] font-bold"
                                            : "text-gray-700 hover:text-green-500 cursor-pointer"
                                        }`
                                    }
                                >
                                    <FiPlusSquare className="mr-2 text-sm" />
                                    ایجاد معیار
                                </NavLink>
                            </li>
                        </motion.ul>

                        {/* ایجاد قیف آماده */}
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{
                                height: openMenu === "FunnelManager" ? "auto" : 0,
                                opacity: openMenu === "FunnelManager" ? 1 : 0,
                            }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to="/admin/create-ready-funnel"
                                    onClick={() => handleClick("createReadyFunnel")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear
                    ${isActive
                                            ? "bg-[#aadec5] font-bold"
                                            : "text-gray-700 hover:text-green-500 cursor-pointer"
                                        }`
                                    }
                                >
                                    <FiLayers className="mr-2 text-sm" />
                                    ایجاد قیف آماده
                                </NavLink>
                            </li>
                        </motion.ul>

                        {/* لیست قیف های آماده */}
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{
                                height: openMenu === "FunnelManager" ? "auto" : 0,
                                opacity: openMenu === "FunnelManager" ? 1 : 0,
                            }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to="/admin/ready-funnels"
                                    onClick={() => handleClick("readyFunnels")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear
                    ${isActive
                                            ? "bg-[#aadec5] font-bold"
                                            : "text-gray-700 hover:text-green-500 cursor-pointer"
                                        }`
                                    }
                                >
                                    <FiList className="mr-2 text-sm" />
                                    لیست قیف های آماده
                                </NavLink>
                            </li>
                        </motion.ul>
                    </li>
                    
                    {/* تنظیمات */}
                    <li>
                        <a
                            onClick={(e) => { e.stopPropagation(); toggleMenu("setting") }}
                            className="w-full flex items-center justify-between pl-1 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <IoSettingsOutline className="mr-2 text-lg" />
                            <span data-key="t-apps" className="w-full">تنظیمات
                                <FiChevronDown className={`mr-[7.3rem] transform transition-transform ${openMenu === "setting" ? "rotate-180" : "rotate-0"} `} />
                            </span>

                        </a>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "setting" ? "auto" : 0, opacity: openMenu === "setting" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/setting'
                                    onClick={() => handleClick("FinanceSettings")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <MdAccountBalanceWallet className="mr-2 text-sm" />

                                    تنظیمات کلی
                                </NavLink>
                            </li>
                        </motion.ul>

                    </li>
                    <li>
                        <a
                            onClick={(e) => { e.stopPropagation(); toggleMenu("user") }}
                            className="w-full flex items-center justify-between pl-1 pr-4 py-3 text-sm font-medium
                             text-gray-700 hover:text-green-500 dark:text-gray-300 dark:hover:text-white cursor-pointer"
                        >
                            <FiUser className="mr-2 text-lg" />
                            <span data-key="t-apps" className="w-full">مشخصات حساب کاربری
                                <FiChevronDown className={`mr-[2rem] transform transition-transform ${openMenu === "user" ? "rotate-180" : "rotate-0"} `} />
                            </span>

                        </a>
                        <motion.ul
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: openMenu === "user" ? "auto" : 0, opacity: openMenu === "user" ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                            className="overflow-hidden"
                        >
                            <li>
                                <NavLink
                                    to='/admin/changePassword'
                                    onClick={() => handleClick("changeAdminPassword")}
                                    className={({ isActive }) =>
                                        `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
                                      ${isActive ? "bg-[#aadec5] font-bold " : "text-gray-700 hover:text-green-500 cursor-pointer"}`
                                    }
                                >
                                    <FiLock className="mr-2 text-sm" />
                                    تغییر رمز حساب کاربری
                                </NavLink>
                            </li>
                        </motion.ul>
                    </li>
                </ul>
            </div>
        </SimpleBar>
    );
};

export default AdminSidebar;


